import Flexbox from './flexbox'
import FlexboxItem from './flexbox-item'

export {
  Flexbox,
  FlexboxItem
}



// WEBPACK FOOTER //
// ./~/vux/src/components/flexbox/index.js